import React, { useState } from 'react'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css'

function ODateTimePicker ({ handleDateTimeChange, value }) {
  const [dateTime, setDateTime] = useState(value || '')

  const onChange = ([selectedDateTime]) => {
    setDateTime(selectedDateTime)
    handleDateTimeChange(selectedDateTime)
  }
  
  return (
    <Flatpickr
      className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0 peer'
      name='dateTime'
      placeholder='Select date and time'
      options={{
        enableTime: true,
        minDate: 'today',
        dateFormat: 'm-d-Y H:i',
        time_24hr: false,
        defaultDate: dateTime
      }}
      onChange={onChange}
    />
  )
}

export default ODateTimePicker